import { defineMessages } from 'react-intl';

export default defineMessages({
  commits: {
    id: 'frontbucket.repository.commit.breadcrumbs.commits',
    description: 'Text to display on commits breadcrumbs',
    defaultMessage: 'Commits',
  },
  commit: {
    id: 'frontbucket.repository.commit.breadcrumbs.commit',
    description: 'Text to display as title for commit page',
    defaultMessage: 'Commit',
  },
  committed: {
    id: 'frontbucket.repository.commit.verbs.committed',
    description: 'Text to display saying that someone committed this commit',
    defaultMessage: 'committed',
  },
  hashCopied: {
    id: 'frontbucket.repository.commit.copyHash.hashCopied',
    description: 'Tooltip text for successful hash copy',
    defaultMessage: 'Commit hash copied to clipboard!',
  },
  copyHash: {
    id: 'frontbucket.repository.commit.copyHash.copyHash',
    description: 'Tooltip text to prompt user to copy commit hash',
    defaultMessage: 'Copy commit hash to clipboard',
  },
  commentsGlobalTitle: {
    id: 'frontbucket.repository.commitConversation.globalTitle',
    description: 'Title of global comments section on a commit page',
    defaultMessage:
      '{count, plural, one {{count} comment} other {{count} comments}}',
  },
  commentsGlobalAddComment: {
    id: 'frontbucket.repository.commit.globalAddComment',
    description: 'Placeholder text in global comments section on a commit page',
    defaultMessage: 'Add a comment',
  },
  globalConversationLabel: {
    id: 'frontbucket.repository.commit.globalLabel',
    description: 'Label for the global comments section on a commit page',
    defaultMessage: 'Global comments',
  },
  loginLinkText: {
    id: 'frontbucket.repository.commit.loginLinkText',
    description: 'Text for link to log in page',
    defaultMessage: 'Log in to add a comment',
  },
  approve: {
    id: 'frontbucket.repository.commit.headerActions.approve',
    description: 'Text on button to approve a commit',
    defaultMessage: 'Approve',
  },
  unapprove: {
    id: 'frontbucket.repository.commit.headerActions.unapprove',
    description: 'Text on button to unapprove a commit',
    defaultMessage: 'Unapprove',
  },
  viewSource: {
    id: 'frontbucket.repository.commit.headerActions.viewSource',
    description: 'Text on button to view source for this commit',
    defaultMessage: 'View source',
  },
  viewRawCommit: {
    id: 'frontbucket.repository.commit.headerActions.viewRawCommit',
    description: 'Text on button to view raw commit in dropdown menu',
    defaultMessage: 'View raw commit',
  },
  watchCommit: {
    id: 'frontbucket.repository.commit.headerActions.watchCommit',
    description: 'Text on button to watch commit in dropdown menu',
    defaultMessage: 'Watch',
  },
  unwatchCommit: {
    id: 'frontbucket.repository.commit.headerActions.unwatchCommit',
    description: 'Text on button to stop watching commit in dropdown menu',
    defaultMessage: 'Stop watching',
  },
  unreachableWarning: {
    id: 'frontbucket.repository.commit.unreachableWarning',
    description: 'Text for warning section message',
    defaultMessage:
      'This commit is not reachable from any branch or tag in this repository. It may be from a fork outside of this repository.',
  },
  tags: {
    id: 'frontbucket.repository.commit.sidebar.tags',
    description: 'Text to display for tag header in sidebar',
    defaultMessage: '{count} tags',
  },
  tagLabel: {
    id: 'frontbucket.repository.commit.sidebar.tagLabel',
    description: 'Label to display for collapsed tag in sidebar',
    defaultMessage: 'Tags',
  },
  oneTag: {
    id: 'frontbucket.repository.commit.sidebar.oneTag',
    description: 'Text to display for tag header with one tag in sidebar',
    defaultMessage: '{count} tag',
  },
  tagIcon: {
    id: 'frontbucket.repository.commit.sidebar.tagIcon',
    description: 'Label for tag icon in sidebar',
    defaultMessage: 'Tag icon',
  },
  createTag: {
    id: 'frontbucket.repository.commit.sidebar.createTag',
    description: 'Text in sidebar to create a tag',
    defaultMessage: 'Create tag',
  },
  tagName: {
    id: 'frontbucket.repository.commit.sidebar.tagName',
    description: 'Text in modal form for tag name',
    defaultMessage: 'Tag name',
  },
  tagDescription: {
    id: 'frontbucket.repository.commit.sidebar.tagDescription',
    description: 'Text in modal form for tag description',
    defaultMessage: 'Description',
  },
  tagCancel: {
    id: 'frontbucket.repository.commit.sidebar.tagCancel',
    description: 'Text in modal form to cancel tag creation',
    defaultMessage: 'Cancel',
  },
  tagCreationError: {
    id: 'frontbucket.repository.commit.sidebar.tagCreationError',
    description: 'Text to display when creating a tag errors out',
    defaultMessage: 'Something went wrong. Please try again later.',
  },
  tagOverflowWarning: {
    id: 'frontbucket.repository.commit.sidebar.tagOverflowWarning',
    description: 'Text to display when a commit has more than 25 tags',
    defaultMessage: "Can't display more than 25 tags.",
  },
  participants: {
    id: 'frontbucket.repository.commit.sidebar.participants',
    description: 'Text to display for participants',
    defaultMessage: '{count} participants',
  },
  oneParticipant: {
    id: 'frontbucket.repository.commit.sidebar.oneParticipant',
    description: 'Text to display for one participant',
    defaultMessage: '{count} participant',
  },
  participantsLabel: {
    id: 'frontbucket.repository.commit.sidebar.participantsLabel',
    description: 'Label to display for collapsed participants',
    defaultMessage: 'Participants',
  },
  branches: {
    id: 'frontbucket.repository.commit.sidebar.branches',
    description: 'Text to display for branches',
    defaultMessage: '{count} branches',
  },
  oneBranch: {
    id: 'frontbucket.repository.commit.sidebar.oneBranch',
    description: 'Text to display for one branch',
    defaultMessage: '{count} branch',
  },
  branchesLabel: {
    id: 'frontbucket.repository.commit.sidebar.branchesLabel',
    description: 'Label to display for collapsed branches',
    defaultMessage: 'Branches',
  },
  loadingBranches: {
    id: 'frontbucket.repository.commit.sidebar.loadingBranches',
    description: 'Text to display for loading branches information',
    defaultMessage: 'Loading branch data',
  },
  parentCommits: {
    id: 'frontbucket.repository.commit.sidebar.parentCommits',
    description: 'Text to display for parent commits',
    defaultMessage: '{count} parent commits',
  },
  oneParentCommit: {
    id: 'frontbucket.repository.commit.sidebar.oneParentCommit',
    description: 'Text to display for one parent commit',
    defaultMessage: '{count} parent commit',
  },
  parentCommitsLabel: {
    id: 'frontbucket.repository.commit.sidebar.parentCommitsLabel',
    description: 'Label to display for collapsed parent commits',
    defaultMessage: 'Parent commits',
  },
  isMerge: {
    id: 'frontbucket.repository.commit.details.isMerge',
    description: 'Text to display is commit is a merge',
    defaultMessage: 'Merge',
  },
  isMergeWithConflicts: {
    id: 'frontbucket.repository.commit.details.isMergeWithConflicts',
    description: 'Text to display is commit is a merge',
    defaultMessage: 'Merge with conflicts',
  },
  apps: {
    id: 'frontbucket.repository.commit.sidebar.apps',
    description: 'Text to display for apps',
    defaultMessage: 'Apps',
  },
  runPipeline: {
    id: 'frontbucket.repository.commit.sidebar.runPipeline',
    description: 'Text to display for "run pipeline" action',
    defaultMessage: 'Run pipeline',
  },
  notfound: {
    id: 'frontbucket.repository.commit.errors.notfound',
    description: 'Header to display when commit is not found (404)',
    defaultMessage: 'Commit not found',
  },
});
